import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import styles from './ProductCardMidtermBadge.module.scss';
import Icon from '@/components/UI/icon/Icon';
import { FC } from 'react';
type ProductCardMidtermBadgeProps = {
  hasVideo: boolean;
};
const ProductCardMidtermBadge: FC<ProductCardMidtermBadgeProps> = ({
  hasVideo
}) => {
  return <>
      <Box className={styles['free-deposit-container']} data-sentry-element="Box" data-sentry-source-file="ProductCardMidtermBadge.tsx">
        <Typography color="neutral_min" variant="descriptionL_Bold" data-sentry-element="Typography" data-sentry-source-file="ProductCardMidtermBadge.tsx">
          ودیعه رایگان
        </Typography>
      </Box>
      {hasVideo && <Box className={styles['video-badge-container']}>
          <Box className={styles['video-badge-icon-container']}>
            <Icon name="video-Filled" type="warning"></Icon>
          </Box>
          <Typography color="neutral_main" variant="bodyS">
            ویدیودار
          </Typography>
        </Box>}
    </>;
};
export default ProductCardMidtermBadge;